import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import {Helmet} from "react-helmet";

const propTypes = {
    topOuterDivider: PropTypes.bool,
    topDivider: PropTypes.bool
}

const defaultProps = {
    topOuterDivider: false,
    topDivider: false
}

const Footer = ({
                    className,
                    topOuterDivider,
                    topDivider,
                    ...props
                }) => {

    const classes = classNames(
        'mt-32',
        'site-footer center-content-mobile',
        topOuterDivider && 'has-top-divider',
        className
    );

    return (
        <footer
            {...props}
            className={classes}
        >
            <div className="container">
                <div className={
                    classNames(
                        'site-footer-inner',
                        topDivider && 'has-top-divider'
                    )}>
                    <a className="twitter-timeline" data-height="512" data-theme="dark"
                       href="https://twitter.com/hope06472617?ref_src=twsrc%5Etfw">Tweets by Info_OASYS_Tech</a>
                <Helmet>
                <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>

            </Helmet>
                </div>
            </div>

            <div className="container">
                <div className={
                    classNames(
                        'site-footer-inner',
                        topDivider && 'has-top-divider'
                    )}>
                    <div className="footer-top space-between text-xxs">
                        <Logo/>
                        <FooterNav/>
                    </div>
                    <div className="footer-bottom space-between text-xxs invert-order-desktop">
                        <div className="footer-copyright">copyright 特定非営利活動法人HOPE</div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;